import { Component, OnInit, ViewChild, inject } from '@angular/core'
import { DataBindingDirective } from '@progress/kendo-angular-grid'

import { Enums, Profile } from '@cyborg-monorepo/hunter/common'
import { DialogRef, DialogService } from '@hyperkit'

import { DeleteUserDialogComponent } from '../../../account/components/manage-users/delete-user-dialog/delete-user-dialog.component'
import { EditUserDialogComponent } from '../../../account/components/manage-users/edit-user-dialog/edit-user-dialog.component'
import { NewUserDialogComponent } from '../../../account/components/manage-users/new-user-dialog/new-user-dialog.component'
import { UserService } from '../../../shared/services/user.service'

@Component({
  standalone: false,
  templateUrl: './mu.component.html',
  styleUrls: ['./mu.component.scss'],
})
export class ManageUsersComponent implements OnInit {
  private userService = inject(UserService)
  private dialogService = inject(DialogService)

  public users: Array<Profile>
  public isAdmin = false
  @ViewChild(DataBindingDirective) public dataBinding: DataBindingDirective
  public gridData: Profile[]
  public gridView: Profile[]

  public ngOnInit(): void {
    this.getUserList()
    this.getRole()
  }

  private getRole(): void {
    this.userService.loadProfile().subscribe((profile: Profile) => {
      this.isAdmin = profile.role == Enums.UserRoleEnum.ADMINISTRATOR
    })
  }

  private getUserList(): void {
    this.userService.getUsers().subscribe((val: Profile[]) => {
      this.users = val
      this.gridData = this.gridView = this.users
    })
  }
  public onAddUserModal(): void {
    const dialogRef: DialogRef = this.dialogService.open(NewUserDialogComponent)

    dialogRef.afterClosed().subscribe((user: Profile) => {
      if (user) {
        this.getUserList()
      }
    })
  }
  public editUser(user: Profile): void {
    const dialogRef: DialogRef = this.dialogService.open(
      EditUserDialogComponent,
      { data: user },
    )

    dialogRef.afterClosed().subscribe(() => {
      this.getUserList()
    })
  }

  public deleteUser(user: Profile): void {
    const dialogRef: DialogRef = this.dialogService.open(
      DeleteUserDialogComponent,
      { data: user },
    )

    dialogRef.afterClosed().subscribe(() => {
      this.getUserList()
    })
  }

  public onFilter(input: string): void {
    this.gridView = this.gridData.filter((user: Profile) => {
      return (
        user.email.toLowerCase().indexOf(input.toLowerCase()) != -1 ||
        user.role.toLowerCase().indexOf(input.toLowerCase()) != -1 ||
        (user.firstName + ' ' + user.lastName)
          .toLowerCase()
          .indexOf(input.toLowerCase()) != -1
      )
    })
  }
}
